<div class="bg-none flex flex-col w-full mt-[-2.5rem] gap-1 referral-page">
  <div class="flex flex-col items-center justify-center">
    <div class="flex flex-col w-[96%] bg-white rounded-md border px-3 ml-2 mr-2 shadow-sm referral-toolbar-card">
      <div class="flex flex-col gap-2 py-3">
        <div class="flex flex-wrap items-center gap-2">
          <div class="relative ml-2 w-full sm:w-[340px] min-w-[220px] shrink-0">
            <span class="pointer-events-none absolute left-3 top-1/2 z-10 -translate-y-1/2">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M15.5 14.0006H14.71L14.43 13.7306C15.63 12.3306 16.25 10.4206 15.91 8.39063C15.44 5.61063 13.12 3.39063 10.32 3.05063C6.09001 2.53063 2.53002 6.09063 3.05002 10.3206C3.39002 13.1206 5.61002 15.4406 8.39002 15.9106C10.42 16.2506 12.33 15.6306 13.73 14.4306L14 14.7106V15.5006L18.25 19.7506C18.66 20.1606 19.33 20.1606 19.74 19.7506C20.15 19.3406 20.15 18.6706 19.74 18.2606L15.5 14.0006ZM9.50002 14.0006C7.01002 14.0006 5.00002 11.9906 5.00002 9.50063C5.00002 7.01063 7.01002 5.00063 9.50002 5.00063C11.99 5.00063 14 7.01063 14 9.50063C14 11.9906 11.99 14.0006 9.50002 14.0006Z" fill="#00358E"/>
              </svg>
            </span>

            <input
              type="search"
              placeholder="Search referrals"
              [(ngModel)]="searchText"
              (keyup.enter)="onSearchClick()"
              class="w-full text-[14px] font-normal leading-[20px] h-[40px] pl-10 pr-3 py-2 rounded-md border-solid border-2 shadow-none outline-1 referral-input"
            />
          </div>

          <div class="relative inline-block shrink-0" data-referral-filter-scope="true">
            <button
              type="button"
              (click)="toggleFilterDropdown()"
              class="ml-2 px-3 py-2 rounded-lg text-gray-700 bg-none focus:outline-none flex items-center gap-2"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M3 6H21L14 14V19L10 21V14L3 6Z" fill="#00358E"/>
              </svg>
              <span class="text-sm font-medium text-[#00358E]">Filter By</span>
            </button>

            <div
              *ngIf="filterDropdownOpen"
              class="referral-filter-dropdown absolute left-0 mt-2 w-[36rem] bg-white border rounded-md shadow-2xl z-50"
            >
              <div class="border-b flex justify-between items-center border-gray-200 p-3 px-6">
                <h3 class="text-lg font-semibold text-[#00358E]">Filter By</h3>
                <button type="button" (click)="toggleFilterDropdown()" class="text-gray-500 hover:text-gray-800">✕</button>
              </div>

              <div class="grid grid-cols-1 md:grid-cols-3 gap-2 p-4 max-h-[340px] overflow-y-auto">
                <div class="px-2">
                  <p class="font-semibold text-black text-base mb-2">Type of Referral</p>
                  <div class="space-y-1.5">
                    <label
                      *ngFor="let option of typeOfReferralOptions"
                      class="flex items-center space-x-2.5 cursor-pointer text-xs font-normal leading-[20px] text-black hover:text-gray-800 py-0.5 rounded hover:bg-gray-50"
                    >
                      <input
                        type="checkbox"
                        [checked]="tempSelectedTypeOfReferralFilters.includes(option)"
                        (change)="onFilterCheckboxChange('typeOfReferral', option, $any($event.target).checked)"
                        class="rounded border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                      />
                      <span>{{ option }}</span>
                    </label>
                  </div>
                </div>

                <div class="px-2">
                  <p class="font-semibold text-black text-base mb-2">Service Type</p>
                  <div class="space-y-1.5">
                    <label
                      *ngIf="serviceTypeOptions.length > 0"
                      class="flex items-center space-x-2.5 cursor-pointer text-xs font-normal leading-[20px] text-black hover:text-gray-800 py-0.5 rounded hover:bg-gray-50"
                    >
                      <input
                        type="checkbox"
                        [checked]="tempSelectedServiceTypeFilters.length === serviceTypeOptions.length"
                        (change)="onFilterCheckboxChange('serviceType', allServiceTypesOption, $any($event.target).checked)"
                        class="rounded border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                      />
                      <span>{{ allServiceTypesOption }}</span>
                    </label>
                    <label
                      *ngFor="let option of serviceTypeOptions"
                      class="flex items-center space-x-2.5 cursor-pointer text-xs font-normal leading-[20px] text-black hover:text-gray-800 py-0.5 rounded hover:bg-gray-50"
                    >
                      <input
                        type="checkbox"
                        [checked]="tempSelectedServiceTypeFilters.includes(option)"
                        (change)="onFilterCheckboxChange('serviceType', option, $any($event.target).checked)"
                        class="rounded border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                      />
                      <span>{{ option }}</span>
                    </label>
                  </div>
                </div>

                <div class="px-2">
                  <p class="font-semibold text-black text-base mb-2">Service Action</p>
                  <div class="space-y-1.5">
                    <label
                      *ngIf="serviceActionOptions.length > 0"
                      class="flex items-center space-x-2.5 cursor-pointer text-xs font-normal leading-[20px] text-black hover:text-gray-800 py-0.5 rounded hover:bg-gray-50"
                    >
                      <input
                        type="checkbox"
                        [checked]="tempSelectedServiceActionFilters.length === serviceActionOptions.length"
                        (change)="onFilterCheckboxChange('serviceAction', allServiceActionsOption, $any($event.target).checked)"
                        class="rounded border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                      />
                      <span>{{ allServiceActionsOption }}</span>
                    </label>
                    <label
                      *ngFor="let option of serviceActionOptions"
                      class="flex items-center space-x-2.5 cursor-pointer text-xs font-normal leading-[20px] text-black hover:text-gray-800 py-0.5 rounded hover:bg-gray-50"
                    >
                      <input
                        type="checkbox"
                        [checked]="tempSelectedServiceActionFilters.includes(option)"
                        (change)="onFilterCheckboxChange('serviceAction', option, $any($event.target).checked)"
                        class="rounded border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                      />
                      <span>{{ option }}</span>
                    </label>
                  </div>
                </div>
              </div>

              <div class="flex justify-end gap-2.5 p-3 border-t border-gray-200 bg-[#00358E] rounded-b-md">
                <button
                  type="button"
                  (click)="clearTempFilters()"
                  class="px-3 py-1.5 text-sm text-white font-medium rounded-lg tracking-[0.1px] leading-[20px] transition-colors"
                >
                  Clear filter
                </button>
                <button
                  type="button"
                  (click)="applyFilters()"
                  class="px-3 mr-2 py-1.5 text-sm font-medium bg-white tracking-[0.1px] leading-[20px] text-[#00358E] rounded-full hover:bg-[#e4e3e3] transition-colors"
                >
                  Apply Filter
                </button>
              </div>
            </div>
          </div>

          <div class="flex items-center gap-2 min-w-0 shrink-0">
            <select
              [(ngModel)]="selectedMissingDataFilter"
              class="h-[40px] min-w-[170px] rounded-md border-2 border-solid px-3 text-[14px] font-normal leading-[20px] referral-select shrink-0"
              (change)="onFilterChange()"
            >
              <option value="">All</option>
              <option value="no_service_type">No Service Type</option>
              <option value="no_service_id">No Service Id</option>
            </select>

            <select
              [(ngModel)]="requestedDateFilter"
              class="h-[40px] min-w-[200px] rounded-md border-2 border-solid px-3 text-[14px] font-normal leading-[20px] referral-select shrink-0"
              (change)="onRequestedDateFilterChange()"
            >
              <option value="">All Requested Dates</option>
              <option value="last7">Last 7 days</option>
              <option value="last30">Last 30 days</option>
              <option value="last90">Last 90 days</option>
              <option value="custom">Custom date range</option>
            </select>

            <div *ngIf="requestedDateFilter === 'custom'" class="flex items-center gap-2 shrink-0">
              <input
                type="date"
                [(ngModel)]="customRequestedDateFrom"
                (change)="onCustomRequestedDateChange()"
                class="h-[40px] min-w-[135px] rounded-md border-2 border-solid px-3 text-[14px] font-normal leading-[20px] referral-input"
                placeholder="From"
              />
              <span class="text-sm text-gray-500">to</span>
              <input
                type="date"
                [(ngModel)]="customRequestedDateTo"
                (change)="onCustomRequestedDateChange()"
                class="h-[40px] min-w-[135px] rounded-md border-2 border-solid px-3 text-[14px] font-normal leading-[20px] referral-input"
                placeholder="To"
              />
            </div>
          </div>

          <div class="flex items-center gap-2 ml-auto shrink-0">
          <button
            oriButton
            variant="noHover"
            type="button"
            class="px-6 py-3 h-[40px] min-h-[40px] max-h-[40px] rounded-full text-white font-medium text-[14px] leading-[20px] tracking-[0.1px] flex items-center justify-center bg-[#00358E] hover:bg-[#002766] transition-colors"
            (click)="onSearchClick()"
          >
            Search
          </button>

          <button
            oriButton
            variant="noHover"
            type="button"
            class="px-6 py-3 h-[40px] min-h-[40px] max-h-[40px] rounded-full bg-white border text-[14px] font-medium border-[#00358E] text-[#00358E] flex items-center justify-center hover:bg-[#e4e3e3] transition-colors"
            (click)="onResetFilters()"
          >
            Reset
          </button>

          <button
            oriButton
            variant="noHover"
            type="button"
            class="px-6 py-3 h-[40px] min-h-[40px] max-h-[40px] rounded-full bg-white border text-[14px] font-medium border-[#00358E] text-[#00358E] flex items-center justify-center hover:bg-[#e4e3e3] transition-colors"
            (click)="onOpenReports()"
          >
            Reports
          </button>

          <button
            *ngIf="canAddReferral()"
            oriButton
            variant="noHover"
            type="button"
            class="px-6 py-3 rounded-[44px] h-[40px] min-h-[40px] max-h-[40px] text-white font-medium text-[14px] leading-[20px] tracking-[0.1px] flex items-center justify-center gap-2 bg-[#00358E] hover:bg-[#002766] transition-colors"
            (click)="onAddNewReferral()"
          >
            Add New Referral
          </button>
          </div>
        </div>
      </div>

      <div class="w-full flex flex-wrap pl-5 mb-2 gap-2" *ngIf="activeFilterChips().length > 0">
        <ng-container *ngFor="let chip of activeFilterChips()">
          <span class="px-3 py-2 gap-2 border border-solid border-[#757575] inline-flex items-center justify-center rounded-full">
            {{ chip.value }}
            <button
              type="button"
              class="font-medium text-black text-[14px] p-[5px] leading-[20px] tracking-[0.1px] cursor-pointer"
              [attr.data-filter-key]="chip.key"
              [attr.data-filter-value]="chip.value"
              (mouseup)="handleRemoveFilter($event)"
            >
              ✕
            </button>
          </span>
        </ng-container>
      </div>

    </div>
  </div>

  <div class="flex flex-col items-center justify-center">
    <div class="w-[96%] bg-white rounded-md border px-4 py-4 ml-2 mr-2 shadow-sm referral-grid-card">
      <div *ngIf="saveSuccessMessage" class="success-message">{{ saveSuccessMessage }}</div>

      <kendo-grid
  class="referral-grid"
  [data]="referrals"
  [height]="520"
  [loading]="loading"
  (cellClick)="onRowClick($event.dataItem)"
>
        <kendo-grid-column field="refNumber" title="Referral Number">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div [title]="dataItem.refNumber" class="truncate">{{ dataItem.refNumber }}</div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="dateRequested" [sortable]="false" [title]="''">
          <ng-template kendoGridHeaderTemplate>
            <div class="flex items-center gap-2 cursor-pointer select-none" (click)="onSortByDate()">
              <span class="text-xs font-semibold">Date Requested</span>
              <div class="flex flex-col items-center justify-center">
                <span 
                  class="text-[9px] leading-none"
                  [style.opacity]="sortOrder === 'asc' ? '1' : '0.4'"
                  [style.color]="'white'"
                >▲</span>
                <span 
                  class="text-[7px] leading-none"
                  [style.opacity]="sortOrder === 'desc' ? '1' : '0.4'"
                  [style.color]="'white'"
                >▼</span>
              </div>
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="vettingDate" title="Vetting Date">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div [title]="dataItem.vettingDate" class="truncate">{{ dataItem.vettingDate }}</div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="typeOfReferral" title="Type of Referral">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div [title]="dataItem.typeOfReferral" class="truncate">{{ dataItem.typeOfReferral }}</div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="claimantName" title="Claimant Name">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div [title]="dataItem.claimantName" class="truncate">{{ dataItem.claimantName }}</div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="claimNumber" title="Claim Number">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div [title]="dataItem.claimNumber" class="whitespace-normal break-words">{{ dataItem.claimNumber }}</div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="vendorName" title="Vendor Name">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div [title]="dataItem.vendorName" class="truncate">{{ dataItem.vendorName }}</div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Service Type" [width]="340">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="service-cell-list">
              <div *ngFor="let service of getServiceDisplayEntries(dataItem)" 
                   class="service-cell-entry" 
                   [title]="service.serviceType + (service.action ? ' - ' + service.action : '') + (service.serviceDataID ? ' (' + service.serviceDataID + ')' : '')">
                <span class="service-entry-type">{{ service.serviceType }}</span>
                <span *ngIf="service.action" class="service-entry-action">- {{ service.action }}</span>
                <ng-container *ngIf="service.serviceDataID; else missingServiceId">
                  <span class="service-entry-id">({{ service.serviceDataID }})</span>
                </ng-container>
                <ng-template #missingServiceId>
                  <span *ngIf="IsServiceIdRequiredForService(dataItem, service)" class="service-missing-id" title="Service Data ID is missing" aria-label="Service Data ID missing">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                      <path d="M12 2L1 21H23L12 2Z" fill="#F59E0B"/>
                      <path d="M12 8V13" stroke="#111827" stroke-width="2" stroke-linecap="round"/>
                      <circle cx="12" cy="17" r="1.25" fill="#111827"/>
                    </svg>
                  </span>
                </ng-template>
              </div>
              <div *ngIf="getServiceDisplayEntries(dataItem).length === 0" class="service-cell-empty">-</div>
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column *ngIf="canDeleteReferral()" title="Actions" [width]="130">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="row-actions">
              <!--<button type="button" class="link-button" (click)="onEditRow(dataItem); $event.stopPropagation()">Edit</button>-->
              <button type="button" class="link-button delete" (click)="onDeleteRow(dataItem); $event.stopPropagation()">Delete</button>
            </div>
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>
<div class="custom-pager">
  <button
    class="pager-link"
    (click)="previousPage()"
    [disabled]="currentPage === 0 || loading">
     Previous
  </button>

  <span class="page-number">
    {{ currentPage + 1 }}
  </span>

  <button
    class="pager-link"
    (click)="nextPage()"
    [disabled]="!hasMorePages || loading">
    Next
  </button>
      <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>
        <div *ngIf="countLoading || matchingCount !== null" class="w-full flex justify-end pr-5 mt-1 text-sm font-medium text-[#00358E]">
        {{ countLoading ? 'Loading count...' : (matchingCount + ' referral' + (matchingCount === 1 ? '' : 's') + ' found') }}
      </div>
    </div>
  </div>
</div>

<app-referral-reports-dialog [isOpen]="isReportsOpen" (closed)="onCloseReports()"></app-referral-reports-dialog>

<div *ngIf="isFormOpen" class="referral-modal-backdrop" (click)="closeReferralForm()"></div>

<div *ngIf="isFormOpen" class="referral-modal" role="dialog" aria-modal="true" aria-label="Referral form">
  <div class="referral-modal-header">
    <h2>Add New Referral</h2>
    <button type="button" class="link-button" (click)="closeReferralForm()">Close</button>
  </div>

  <div class="referral-modal-body">
  <div class="referral-form-grid">
    <label>
      <span>Type Of Referral</span>
      <select [(ngModel)]="formModel.typeOfReferral" class="form-select"
        [ngClass]="{ 'ring-1 ring-red-500 bg-red-50': isReferralFieldInvalid('typeOfReferral') }">
        <option [ngValue]="null">Select Type Of Referral</option>
        <option *ngFor="let option of typeOfReferralOptions" [ngValue]="option">{{ option }}</option>
      </select>
    </label>

    <label>
      <span>Claimant Name</span>
      <input type="text" [(ngModel)]="formModel.claimantName" class="form-control" />
    </label>

    <label>
      <span>Claim Number</span>
      <input type="text" [(ngModel)]="formModel.claimNumber" class="form-control"
        [ngClass]="{ 'ring-1 ring-red-500 bg-red-50': isReferralFieldInvalid('claimNumber') }" />
    </label>

    <label>
  <span>Vendor Name</span>
  <kendo-combobox
  [data]="vendorNameOptions"
  (valueChange)="vendorNameInput = $event"
  [filterable]="true"
  [suggest]="true"
  [allowCustom]="true"
  [kendoDropDownFilter]="{ operator: 'contains' }"
  placeholder="Select or type a vendor name">
</kendo-combobox>
  <span
    *ngIf="isNewVendor"
    class="text-xs text-amber-600 mt-1 block"
    title="This vendor will be added to the config when you save"
  >
    New vendor — will be created and attached.
  </span>
</label>

    <label>
      <span>Date Requested</span>
      <input type="date" [(ngModel)]="formModel.dateRequested" class="form-control" />
    </label>

    <label>
      <span>Vetting Date</span>
      <input type="date" [(ngModel)]="formModel.vettingDate" class="form-control" />
    </label>
    <label class="service-type-field">
      <span>Service Types</span>
      <div class="relative w-full" data-dropdown-scope="true">
        <input
          type="text"
          readonly
          class="form-control cursor-pointer w-full"
          style="padding-right: 2rem;"
          [value]="selectedServiceTypes.join(', ')"
          (click)="toggleServiceTypeDropdown($event)"
          placeholder="Select Service Types"
        />
        <span class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-500">
          <svg class="w-4 h-4" viewBox="0 0 24 24" fill="currentColor"><path d="M7 10h10l-5 6z"></path></svg>
        </span>
      </div>
    </label>
  </div>

  </div>

  <div *ngIf="saveErrorMessage" class="error-message">{{ saveErrorMessage }}</div>

  <div class="referral-modal-actions">
    <button
      oriButton
      variant="noHover"
      type="button"
      class="relative overflow-hidden button-secondary"
      (click)="closeReferralForm()"
      [disabled]="isSaving"
    >
      Cancel
    </button>

    <button
      oriButton
      variant="noHover"
      type="button"
      class="relative overflow-hidden button-primary"
      (click)="onSaveReferral()"
      [disabled]="isSaving"
    >
      {{ isSaving ? 'Saving...' : 'Save Referral' }}
    </button>
  </div>
</div>

<div
  *ngIf="showDeleteConfirm"
  class="fixed inset-0 z-[60] flex items-center justify-center bg-black/40"
  (click)="onCancelDelete()"
>
  <div
    class="bg-white rounded-[8px] shadow-2xl w-[520px] max-w-[90%] p-6"
    (click)="$event.stopPropagation()"
  >
    <p class="text-sm text-[#1F1F1F] leading-6">Do you want to delete referral <strong>{{ referralToDelete?.refNumber }}</strong>?</p>
    <div class="mt-6 flex justify-end gap-3">
      <button
        type="button"
        (click)="onCancelDelete()"
        class="px-5 py-2 rounded-full border border-[#D5D5D5] text-sm font-semibold text-[#1F1F1F] hover:bg-gray-50"
      >
        Cancel
      </button>
      <button
        type="button"
        (click)="onConfirmDelete()"
        class="px-5 py-2 rounded-full bg-[#00358E] text-sm font-semibold text-white hover:brightness-95"
      >
        OK
      </button>
    </div>
  </div>
</div>

<div *ngIf="isServiceTypeDropdownOpen" class="service-type-dropdown" [style.top.px]="serviceTypeDropdownTop" [style.left.px]="serviceTypeDropdownLeft">
  <div *ngIf="serviceTypeOptions.length > 0" class="service-type-option" (click)="onServiceTypeCheckboxChange(allServiceTypesOption, !selectedServiceTypes.length || selectedServiceTypes.length < serviceTypeOptions.length)">
    <input type="checkbox" class="service-type-checkbox"
      [checked]="selectedServiceTypes.length === serviceTypeOptions.length"
      (click)="$event.stopPropagation()"
      (change)="onServiceTypeCheckboxChange(allServiceTypesOption, $any($event.target).checked)"
    />
    <span class="service-type-label">{{ allServiceTypesOption }}</span>
  </div>
  <div *ngFor="let opt of serviceTypeOptions" class="service-type-option" (click)="onServiceTypeCheckboxChange(opt, !selectedServiceTypes.includes(opt))">
    <input type="checkbox" class="service-type-checkbox"
      [checked]="selectedServiceTypes.includes(opt)"
      (click)="$event.stopPropagation()"
      (change)="onServiceTypeCheckboxChange(opt, $any($event.target).checked)"
    />
    <span class="service-type-label">{{ opt }}</span>
  </div>
</div>
